import { colors } from '@mui/material';
import { designTokens } from './tokens';

export const lightPalette = {
  mode: 'light',
  primary: {
    main: designTokens.customColors.primary.main,
    light: designTokens.customColors.primary.light,
    dark: designTokens.customColors.primary.dark,
    contrastText: designTokens.customColors.primary.contrastText,
  },
  secondary: {
    main: designTokens.customColors.secondary.main,
    light: designTokens.customColors.secondary.light,
    dark: designTokens.customColors.secondary.dark,
    contrastText: designTokens.customColors.secondary.contrastText,
  },
  text: {
    primary: colors.blueGrey[900],
    secondary: colors.blueGrey[600],
    disabled: colors.blueGrey[400],
  },
  background: {
    default: colors.common.white,
    paper: colors.common.white,
    dark: '#f6f8fb',
    light: '#fafafa',
    grey: '#cccccc',
  },
  action: {
    active: colors.blueGrey[600],
    hover: designTokens.customColors.action.hover,
    selected: designTokens.customColors.action.selected,
    disabled: designTokens.customColors.action.disabled,
  },
  success: {
    main: '#2e7d32', // Changed from #4caf50 for WCAG AA compliance (6.90:1 contrast)
    light: '#81c784',
    dark: '#1b5e20',
  },
  warning: {
    main: '#f57c00', // Changed from #ff9800 for WCAG AA compliance (4.52:1 contrast)
    light: '#ffb74d',
    dark: '#e65100',
  },
  error: {
    main: '#d32f2f', // Changed from #f44336 for WCAG AA compliance (6.23:1 contrast)
    light: '#e57373',
    dark: '#b71c1c',
  },
  info: {
    main: '#1976d2', // Changed from #2196f3 for WCAG AA compliance (5.14:1 contrast)
    light: '#64b5f6',
    dark: '#0d47a1',
  },
  divider: colors.grey[200],

  // Custom theme colors
  button: {
    main: '#0d151c',
    clickable: 'rgba(211, 211, 211, 0.25)',
    hover: designTokens.customColors.action.hover,
  },
  tab: {
    default: colors.blueGrey[600],
    active: designTokens.customColors.primary.main,
    inactive: '#efeeea',
    inactiveBackground: '#e0e0e0',
    hover: '#edeef1',
    indicator: designTokens.customColors.primary.main,
  },
  header: {
    dark: '#0d151c',
  },
  cancel: colors.red[800],
  icons: 'MediumPurple',
  row: {
    selected: designTokens.customColors.action.selected,
    selectedHover: '#dcdcdc',
  },
  switch: {
    on: designTokens.harvestColors.green,
    off: '#EAE9E7',
  },
  harvestColors: designTokens.harvestColors,
};

export const darkPalette = {
  mode: 'dark',
  primary: {
    // Light blue accents for dark mode
    main: '#7aa7ff',
    light: '#a5c3ff',
    dark: '#3d6fd8',
    contrastText: '#0a0b0e',
  },
  // Neutral greys for secondary actions in dark mode
  secondary: {
    main: '#bdbdbd',
    light: '#e0e0e0',
    dark: '#9e9e9e',
    contrastText: '#0a0b0e',
  },
  text: {
    primary: '#efeeea',
    // Softer graphite for secondary text instead of light blue
    secondary: '#9ea3a9',
    disabled: 'rgba(255, 255, 255, 0.5)',
  },
  background: {
    // Near‑black greys for dark surfaces (replaces dark blue)
    default: '#0f1115',
    paper: '#121418',
    dark: '#0a0b0e',
    grey: '#cccccc',
  },
  action: {
    active: 'rgba(255, 255, 255, 0.54)',
    hover: 'rgba(255, 255, 255, 0.06)',
    selected: 'rgba(255, 255, 255, 0.10)',
    disabled: 'rgba(255, 255, 255, 0.26)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    focus: 'rgba(255, 255, 255, 0.12)',
  },
  success: {
    main: '#66bb6a', // Lighter variant for dark mode visibility
    light: '#81c784',
    dark: '#2e7d32',
  },
  warning: {
    main: '#ffa726', // Lighter variant for dark mode visibility
    light: '#ffb74d',
    dark: '#f57c00',
  },
  error: {
    main: '#ef5350', // Lighter variant for dark mode visibility
    light: '#e57373',
    dark: '#d32f2f',
  },
  info: {
    main: '#42a5f5', // Lighter variant for dark mode visibility
    light: '#64b5f6',
    dark: '#1976d2',
  },
  divider: 'rgba(255, 255, 255, 0.08)',

  // Custom theme colors
  button: {
    main: designTokens.customColors.primary.main,
    clickable: 'rgba(255, 255, 255, 0.08)',
    hover: 'rgba(255, 255, 255, 0.12)',
  },
  tab: {
    default: '#9ea3a9',
    active: '#7aa7ff',
    inactiveBackground: 'rgba(255, 255, 255, 0.04)',
    inactiveText: '#c8cbd0',
    hover: 'rgba(255, 255, 255, 0.12)',
    indicator: '#7aa7ff',
  },
  cancel: colors.red[800],
  icons: 'MediumPurple',
  row: {
    selected: '#1a1c20',
    selectedHover: '#202228',
  },
  switch: {
    on: designTokens.harvestColors.green,
    off: '#EAE9E7',
  },
  harvestColors: designTokens.harvestColors,
};
